import * as Yup from 'yup'

const addNotificationSchema = Yup.object().shape({
  message: Yup.string()
    .required('Message is required')
    .min(1, 'Message must be at least 1 character')
    .max(160, 'Message must not be more than 160 characters'),
})

export default addNotificationSchema
